"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenceStatus = void 0;
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var LicenceStatus;
(function (LicenceStatus) {
    LicenceStatus["ACTIVE"] = "ACTIVE";
    LicenceStatus["INACTIVE"] = "INACTIVE";
})(LicenceStatus = exports.LicenceStatus || (exports.LicenceStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGljZW5jZS5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpY2VuY2UvdHlwZXMvbGljZW5jZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOzs7Ozs7R0FNRztBQUNILElBQVksYUFHWDtBQUhELFdBQVksYUFBYTtJQUN2QixrQ0FBaUIsQ0FBQTtJQUNqQixzQ0FBcUIsQ0FBQTtBQUN2QixDQUFDLEVBSFcsYUFBYSxHQUFiLHFCQUFhLEtBQWIscUJBQWEsUUFHeEIifQ==